<template>
    <div class="show show_block show_empty mb-5" v-if="isActive" @change="sendDataForSaving">
        <div class="row">
            <div class="col-12">
                <div class="form-group mb-3">
                    <label class="form-label">Full Name*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="form.author_name"
                    >
                </div>
            </div>
            <div class="col-12">
                <div class="form-group mb-3">
                    <label for="" class="form-label">Resource*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="form.quote_resource"
                    >
                </div>
            </div>
            <div class="col-12">
                <div class="form-group mb-5">
                    <label for="" class="form-label">Description*</label>
                    <textarea
                        class="form-control pl-4"
                        v-model="form.quote_description"
                    ></textarea>
                </div>
            </div>
        </div>
        <div class="show__actions show__actions_bottom">
            <button
                class="show__cancel"
                @click="$emit('removeQuote',{index: index, type: 'quotes' })"
            >Cancel</button>
            <span class="show__sep"></span>
            <button
                class="show__save"
                @click="closeForm"
            >Save</button>
        </div>
    </div>
        <div class="show show_block" v-else>
            <div class="show__actions">

                <a
                    @click="$emit('activate', index)"
                    href="javascript:void(0)"
                    class="show__edit"
                >
                    Edit
                </a>
                <span class="show__sep"></span>
                <a
                    @click="$emit('removeQuote',{index: index, type: 'quotes' })"
                    href="javascript:void(0)"
                    class="show__delete"
                    area-label="Delete"
                >
                    <svg width="16" height="16" class="icon">
                        <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                    </svg>
                </a>
            </div>
            <h3 class="show__title"> {{ form.author_name }}</h3>
            <span class="show__time"> {{ form.quote_resource }}</span>
            <p> {{form.quote_description }}</p>
        </div>

</template>

<script>
export default {
    name: 'QuoteForm',
    props: {
        isActive: {
            type: Boolean
        },
        index: Number,
        quote: {
            type: Object
        }
    },

    data() {
        return {
            form: {
                index: this.index,
                author_name: null,
                quote_resource: null,
                quote_description: null,
            }
        }
    },
    methods: {
        sendDataForSaving() {
            this.$emit('data-changed', this.form, 'quotes');
        },
        setData() {
            Object.keys(this.quote).forEach((key) => {
                this.form[key] = this.quote[key] ?? null;
            });
        },
        closeForm() {
            this.$emit('saveQuoteForm',  null);
        },
    },
    mounted() {
        this.setData()
    },
    watch: {
        'quote': {
            handler: function (newInfo) {
                if (newInfo !== this.form) {
                    this.setData();
                }
            },
            immediate: true,
        },
    }
}

</script>



<style scoped>

</style>
